import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Box, Container, Typography } from "@material-ui/core";
import "./CustomerREQ.css";
import CustomerMain from "./CustomerMain";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
});

const CustomerREQ = ({ isShaws }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // console.log(newValue);
  };
  return (
    <div className={isShaws ? "customer-details" : "customer-details-after"}>
      <Container>
        {" "}
        <Paper className={classes.root}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Box className="coustomerTab">
              <Typography variant="h6">Customers</Typography>
            </Box>
            <Tab label="New Request" className="newReqShaw" />
            <Tab label="Approved" className="approvedShaw" />
          </Tabs>
        </Paper>
        <CustomerMain value={value} />
      </Container>
    </div>
  );
};

export default CustomerREQ;
